import { MobileProductRow } from '@/components/product-table/MobileProductRow';
import TableCell from '@/components/product-table/TableCell';
import { ColumnDef } from '@/components/product/ProductTable';
import { cn } from '@/lib/utils';
import useCartStore from '@/stores/cartStore';
import { ProductListItem } from '@/types';
import { memo } from 'react';

interface ProductRowProps {
    type: 'mobile' | 'desktop';
    variation: ProductListItem;
    activeColumns?: ColumnDef[];
    onAddToCart: (variation: ProductListItem) => void;
    onProductClick: (slug: string) => void;
    isAuthenticated: boolean;
}

const TableRow = memo(
    ({
        type,
        variation,
        activeColumns,
        onAddToCart,
        onProductClick,
        isAuthenticated,
    }: ProductRowProps) => {
        const isAvailable = variation.inStock;

        const isInCart = useCartStore((state) =>
            state.isVariationInCart(variation.id),
        );

        if (type === 'desktop') {
            return (
                <tr
                    className={cn(
                        'group border-b border-zinc-800/50 transition-colors',
                        isAvailable
                            ? 'hover:bg-zinc-900/40'
                            : 'bg-black/20 opacity-40 grayscale',
                    )}
                >
                    {activeColumns?.map((col) => (
                        <td
                            key={col.id}
                            className={cn(
                                'px-2 py-3 align-middle',
                                col.className,
                            )}
                        >
                            <TableCell
                                id={col.id}
                                variation={variation}
                                isInCart={isInCart}
                                onAddToCart={onAddToCart}
                                isAuthenticated={isAuthenticated}
                                onProductClick={onProductClick}
                            />
                        </td>
                    ))}
                </tr>
            );
        }
        if (type === 'mobile') {
            return (
                <MobileProductRow
                    key={variation.id}
                    variation={variation}
                    handleAddToCart={onAddToCart}
                    onProductClick={onProductClick}
                    isInCart={isInCart}
                    isAvailable={isAvailable}
                />
            );
        }

        return null;
    },
    (prevProps, nextProps) => {
        return (
            prevProps.variation.id === nextProps.variation.id &&
            prevProps.type === nextProps.type &&
            prevProps.isAuthenticated === nextProps.isAuthenticated &&
            JSON.stringify(prevProps.activeColumns) ===
                JSON.stringify(nextProps.activeColumns)
        );
    },
);

TableRow.displayName = 'TableRow';

export default TableRow;
